import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.to ? `https://adlocum.cn${item.to}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1 text-sm flex-wrap">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1">
            {index > 0 && (
              <span className="w-4 h-4 flex items-center justify-center text-foreground-300">
                <i className="ri-arrow-right-s-line text-xs"></i>
              </span>
            )}
            {item.to ? (
              <Link to={item.to} className="text-foreground-400 hover:text-primary-600 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium whitespace-nowrap">{item.label}</span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}